// workaround for importing {Promise} from `es6-promise-polyfill` in `clappr-thumbnails-plugin`

const P = Promise

// eslint-disable-next-line import/no-unused-modules
export {P as Promise}
